import { getAuthHeaders } from "@/utils/authManager";
import { httpCall, httpFetch } from "../../common/util";
import DiariesActionApiMapping from "../Diaries/actionURLMapping";

const _baseUrl = process.env.core_gateway_url || '';

// Helpers
const getActionConfig = (ActionType) => DiariesActionApiMapping[ActionType];
const buildOptions = (ActionType, endpointVersion, overrides = {}) => {
    const { method, url: apiPath } = getActionConfig(ActionType);
    return {
        method,
        headers : getAuthHeaders(),
        url     : `/${endpointVersion}${apiPath}`,
        ...overrides,
    };
};

// API calls
export const createToDo = (ActionType, payload) => {
    return httpCall(buildOptions(ActionType, '2.0',{ data: payload.data }))
};

export const getToDoList = (ActionType, payload) => {
    return httpCall(buildOptions(ActionType, '1.0',{ params: payload }))
};

export const fetchDiaryTags = (ActionType, payload) => {
    return httpCall(buildOptions(ActionType, '2.0',{ params: payload }))
};

// Shared handler for update, complete and cancel
const toDoStatusUpdate = (ActionType, payload) => {
    const { method, url: apiPath } = getActionConfig(ActionType);
    return httpCall({
        method,
        headers : getAuthHeaders(),
        data    : payload,
        url     : `/2.0${apiPath}/${payload.id}`,
    });
};

export const completeToDoDiary = (ActionType, payload) => toDoStatusUpdate(ActionType, payload);
export const cancelToDoDiary = (ActionType, payload) => toDoStatusUpdate(ActionType, payload);
export const updateToDo = (ActionType, payload) => toDoStatusUpdate(ActionType, payload);



// ------------------------
export const getTodoWeekData = (ActionType, payload) => {
    return httpCall({
        method: DiariesActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload,
        url: DiariesActionApiMapping[ActionType].url
    });
};

export const getTodoMonthData = (ActionType, payload) => {
    return httpCall({
        method: DiariesActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload,
        url: DiariesActionApiMapping[ActionType].url
    });
};

export const getDiaryLogs = (ActionType, payload) => {
    return httpCall({
        method: DiariesActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload,
        url: DiariesActionApiMapping[ActionType].url
    });
};

export const getDiaryDetail = (ActionType, payload) => {
    return httpCall({
        method: DiariesActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload,
        url: DiariesActionApiMapping[ActionType].url
    });
};

export const cancelDiary = (ActionType, payload) => {
    return httpFetch({
        url: DiariesActionApiMapping[ActionType].url,
        method: DiariesActionApiMapping[ActionType].method,
        credentials: "include",
        data: payload
    });
};

export const fetchDiaryInfoApi = (ActionType, payload) => {
    return httpCall({
        method: DiariesActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload,
        url: DiariesActionApiMapping[ActionType].url
    });
};

export const getDiarySponsorsApi = (ActionType, payload) => {
    return httpCall({
        method: DiariesActionApiMapping[ActionType].method,
        headers: {
            "Content-Type": "application/json"
        },
        params: payload,
        url: DiariesActionApiMapping[ActionType].url
    });
};

export const changeDiaryOwner = (ActionType, payload) => {
    return httpFetch({
        url: DiariesActionApiMapping[ActionType].url,
        method: DiariesActionApiMapping[ActionType].method,
        credentials: "include",
        data: payload
    });
};

export const updateCaptionTodoApi = (ActionType, payload) => {
    return httpFetch({
        url: DiariesActionApiMapping[ActionType].url,
        method: DiariesActionApiMapping[ActionType].method,
        credentials: "include",
        data: payload
    });
};